<template>
    <div class="sidebar">
        <div class="content">
            <div v-for="item in menus[power]" :class="{'menu-item':true,'cur-item':aciveInd==item.index}"  @click="go(item)">
                <i :class="`fa ${item.icon}`"></i>{{item.name}}
            </div>
            <template v-if="[0,2].includes(power)">
                <div style="color: #9d9d9d" @click="isOpenXH=!isOpenXH" class="menu-item"><i :class="`${isOpenXH?'fa fa-arrow-up':'fa fa-arrow-down'}`"></i>现货管理</div>
                <div v-if="isOpenXH" v-for="item in xhMenus" :class="{'menu-item':true,'cur-item':aciveInd==item.index}"  @click="go(item)">
                    <i :class="`fa ${item.icon}`"></i>{{item.name}}
                </div>
            </template>
            <template v-if="power==0">
                <div style="color: #9d9d9d" @click="isOpenXX=!isOpenXX" class="menu-item"><i :class="`${isOpenXX?'fa fa-arrow-up':'fa fa-arrow-down'}`"></i>晟仔专用</div>
                <div v-if="isOpenXX" v-for="item in xxMenus" :class="{'menu-item':true,'cur-item':aciveInd==item.index}"  @click="go(item)">
                    <i :class="`fa ${item.icon}`"></i>{{item.name}}
                </div>
            </template>
            <template v-if="[0,1].includes(power)">
                <div style="color: #9d9d9d" @click="isOpenConfig=!isOpenConfig" class="menu-item"><i :class="`${isOpenConfig?'fa fa-arrow-up':'fa fa-arrow-down'}`"></i>基础配置</div>
                <div v-if="isOpenConfig" v-for="item in configMenus" :class="{'menu-item':true,'cur-item':aciveInd==item.index}"  @click="go(item)">
                    <i :class="`fa ${item.icon}`"></i>{{item.name}}
                </div>
            </template>
            <img src="../assets/image/sidebar/sidebar-logo.png"  style="width: 90%;position: absolute;left: 5%;bottom: 15px;"/>
        </div>
    </div>
</template>

<script type="application/ecmascript">
    export default {
        name: 'sidebar',//侧边栏
        data () {
            return {
                power:JSON.parse(localStorage.user).role,
                menus:[
                    [
                        {name:'入货管理',path:'/purchase',icon:'fa-cart-arrow-down ',index:'1'},
                        {name:'订单管理',path:'/orders',icon:'fa-calendar-plus-o',index:'2'},
                        {name:'产单管理',path:'/wo',icon:'fa-tachometer',index:'3'},
                        {name:'确认送货',path:'/confirmDel',icon:'fa-truck',index:'4'},
                        {name:'收款管理',path:'/recvPayment',icon:'fa-money',index:'5'},
                        {name:'仓库管理',path:'/warehouse',icon:'fa-align-justify',index:'6'},
                        {name:'数据汇总',path:'/summary',icon:'fa-bar-chart',index:'7'},
                        {name:'线上计价',path:'/countPrice?type=0',icon:'fa-calculator',index:'8'},
                        {name:'线上订单',path:'/eOrder?type=1',icon:'fa-calendar-plus-o',index:'9'},
                        {name:'线上客户',path:'/eClient?type=1',icon:'fa-handshake-o',index:'10'},
                        {name:'线上统计',path:'/eReport',icon:'fa-pie-chart',index:'13'},
                        {name:'纸板管理',path:'/zb?type=0',icon:'fa-file',index:'11'},
                        {name:'数据字典',path:'/dict',icon:'fa-table',index:'12'},
                    ],
                    [
                        {name:'入货管理',path:'/purchase',icon:'fa-cart-arrow-down ',index:'1'},
                        {name:'订单管理',path:'/orders',icon:'fa-calendar-plus-o',index:'2'},
                        {name:'产单管理',path:'/wo',icon:'fa-tachometer',index:'3'},
                        {name:'确认送货',path:'/confirmDel',icon:'fa-truck',index:'4'},
                        {name:'收款管理',path:'/recvPayment',icon:'fa-money',index:'5'},
                        {name:'仓库管理',path:'/warehouse',icon:'fa-align-justify',index:'6'},
                        {name:'数据汇总',path:'/summary',icon:'fa-bar-chart',index:'7'},
                    ],
                    [
                        {name:'线上计价',path:'/countPrice?type=0',icon:'fa-calculator',index:'8'},
                        {name:'线上订单',path:'/eOrder?type=1',icon:'fa-calendar-plus-o',index:'9'},
                        {name:'线上客户',path:'/eClient?type=1',icon:'fa-handshake-o',index:'10'},
                        {name:'纸板管理',path:'/zb?type=0',icon:'fa-file',index:'11'},
                        {name:'数据字典',path:'/dict',icon:'fa-table',index:'12'},
                    ],
                    [],
                ],
                configMenus:[
                    {name:'客户管理',path:'/client',icon:'fa-handshake-o',index:'20'},
                    {name:'供应商',path:'/supplier',icon:'fa-ambulance',index:'21'},
                    {name:'系统用户',path:'/user',icon:'fa-lock',index:'22'},
                    {name:'公式管理',path:'/formula',icon:'fa-sort-numeric-asc',index:'23'},
                    {name:'成品仓库',path:'/inventory',icon:'fa-stack-exchange',index:'24'},
                ],
                xxMenus:[
                    {name:'线下计价',path:'/countPrice?type=1',icon:'fa-calculator',index:'30'},
                    {name:'线下订单',path:'/eOrder?type=2',icon:'fa-calendar-plus-o',index:'31'},
                    {name:'毛利计算',path:'/mljs',icon:'fa-calculator',index:'32'},
                    {name:'线下客户',path:'/eClient?type=2',icon:'fa-handshake-o',index:'33'},
                    {name:'线下纸板',path:'/zb?type=1',icon:'fa-file',index:'34'},
                ],
                xhMenus:[
                    {name:'现货计价',path:'/countPrice?type=2',icon:'fa-calculator',index:'40'},
                    {name:'现货订单',path:'/eOrder?type=3',icon:'fa-calendar-plus-o',index:'41'},
                    {name:'现货纸板',path:'/zb?type=2',icon:'fa-file',index:'42'},
                ],
                aciveInd:'',
                user:JSON.parse(localStorage.user),
                isOpenConfig:false,
                isOpenXX:false,
                isOpenXH:false,
            }
        },
        mounted(){
            this.matchActive();
        },
        watch: {
            "$route": "matchActive",
        },
        methods:{
            matchActive(){
                console.log(this.$route);
                let path = this.$route.fullPath;
                for (let i = 0; i < this.menus[this.power].length; i++) {
                    let obj = this.menus[this.power][i];
                    if(obj.path == path){
                        return this.aciveInd = obj.index;
                    }
                }
                for (let i = 0; i < this.configMenus.length; i++) {
                    let obj = this.configMenus[i];
                    if(obj.path == path){
                        this.isOpenConfig = true;
                        return this.aciveInd = obj.index;
                    }
                }
                for (let i = 0; i < this.xxMenus.length; i++) {
                    let obj = this.xxMenus[i];
                    if(obj.path == path){
                        this.isOpenXX = true;
                        return this.aciveInd = obj.index;
                    }
                }
                for (let i = 0; i < this.xhMenus.length; i++) {
                    let obj = this.xhMenus[i];
                    if(obj.path == path){
                        this.isOpenXH = true;
                        return this.aciveInd = obj.index;
                    }
                }
            },
            go(item){
                this.$router.push({path:item.path})
            },
        }
    }
</script>

<style scoped>
    .sidebar{
        width: 150px;height: calc(100vh - 24px); padding: 12px 10px;position: fixed;color:#F8F9FA;
        background:rgb(44,64,81);

    }
    .menu-item{
       padding: 20px;border-radius: 5px;cursor: pointer;
    }
    .menu-item .fa{
        margin-right: 10px;
    }
    .cur-item{
        background:rgb(245,108,108);cursor:default;
    }
    .content{
        height: calc(100vh - 140px);
        overflow-y: auto;
    }
</style>